import {enum_domExceptionsNames, enum_osNames, enum_runIn_es} from "../../functions/src/shareCode/Share_S_Enum";
import {notification_notify} from "./S_Notification";
import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";
import {FB_OsInfo} from "../../functions/src/shareCode/Share_S_Classes";

let geoLocationId = null

// nav_geoLocation_watch_f
// stop when device on sleep mode
export const navigator_watchPosition_start_f = (cb_f) => {

    if(geoLocationId != null){
        navigator_watchPosition_clear_f()
    }

    geoLocationId = navigator
        .geolocation
        .watchPosition(
            cb_f,
            (error) => {
                if (error.code === error.PERMISSION_DENIED){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_weAccessLocation)
                }
            },
            {
                enableHighAccuracy: true,
                maximumAge:600000,
                // timeout:5000,
            })

}

// nav_geoLocation_clear_f
export const navigator_watchPosition_clear_f = () => {

    if(geoLocationId  != null){
        navigator.geolocation.clearWatch(geoLocationId)
        geoLocationId = null
    }

}

// navigator_vibrate_f
export const navigator_vibrate_f = (pattern_an) => {


    if(navigator.vibrate != null){
        navigator.vibrate(pattern_an)

    } else if(navigator.mozVibrate != null){
        navigator.mozVibrate(pattern_an)
    }
}

// navigator_getVideoStream_f
let stream;
export const navigator_getVideoStream_f = (audio_b, cb_success, cb_notAllowedError_f, cb_notFoundError_f ) => {

    if(stream != null){
        navigator_videoStream_stop_f()
    }


    navigator.mediaDevices.getUserMedia(
        {
            audio: audio_b,
            video: {
                width: 500,
                height: 500,
                facingMode: { exact: "environment" }
            }
        })
        .then((stream_l) => {

            stream = stream_l;
            cb_success(stream_l)
        })
        .catch((err) =>{


            console.log(err.name)
            switch(err.name){

                case enum_domExceptionsNames.NotAllowedError:
                    cb_notAllowedError_f()
                    break;

                case enum_domExceptionsNames.NotFoundError:
                    cb_notFoundError_f()
                    break;
            }
        });

    // navigator.getMedia = (
    //     navigator.getUserMedia || // use the proper vendor prefix
    //     navigator.webkitGetUserMedia ||
    //     navigator.mozGetUserMedia ||
    //     navigator.msGetUserMedia);
    //
    // // set camera to back / front is 'user'
    // navigator.getMedia({video: { facingMode: "environment"}}, (stream_l) => {
    //     stream = stream_l;
    //     cb_success(stream_l)
    // }, cb_failed);

}
export const navigator_videoStream_stop_f = () => {
    if(stream != null){
        stream.getTracks().forEach(track => track.stop())
    }
    stream = null
}
export const navigator_turnOfOnFlash_f = () => {
    if(stream == null){
        return
    }

    stream.getVideoTracks()[0].applyConstraints({
        advanced: [{torch: true}]
    });
}
export const navigator_haveAcessToUserMedia_fb = () => {
    return navigator.mediaDevices != null && navigator.mediaDevices.getUserMedia != null
}

// nav_getOsInfo_f
export const navigator_getOsInfo_fc     = () => {

    let nVer = navigator.appVersion;
    let nAgt = navigator.userAgent;

    let majorVersion        = nav_getOsInfo_majorVersion_f(nVer)
    let browserAndVersion   =  nav_getOsInfo_browserAndVersion_f(nAgt, majorVersion)
    let osAndVersion        = nav_getOsInfo_osAndVersion_f(nAgt);


    let ans = new FB_OsInfo({
        oi_browserName_s            : browserAndVersion.browser,
        oi_browserVersion_s         : browserAndVersion.version,
        oi_browserMajorVersion_n    : majorVersion,

        oi_osName_s                 : osAndVersion.os,
        oi_osVersion_s              : osAndVersion.version,

        oi_mobile_b                 : /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer),
        oi_screen_s                 : nav_getOsInfo_screenSize_f(),
        oi_cookies_b                : nav_getOsInfo_cookieEnabled_fb(),
    })


    return ans
}
const nav_getOsInfo_screenSize_f        = () => {
    let screenSize = '';
    if (screen.width) {
        let width = (screen.width) ? screen.width : '';
        let height = (screen.height) ? screen.height : '';
        screenSize += '' + width + " x " + height;
    }
    return screenSize
}
const nav_getOsInfo_majorVersion_f      = (nVer) => {
    let majorVersion = parseInt(nVer, 10);
    majorVersion = parseInt('' + majorVersion.version, 10);
    if (isNaN(majorVersion)) {
        majorVersion = parseInt(nVer, 10);
    }

    return majorVersion
}
const nav_getOsInfo_cookieEnabled_fb    = () => {
    let cookieEnabled = navigator.cookieEnabled;
    if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled
}
const nav_getOsInfo_browserAndVersion_f = (nAgt, majorVersion) => {

    let nameOffset, verOffset, ix;

    let browser = navigator.appName;
    let version = '' + parseFloat(navigator.appVersion);
    // Opera
    if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
    }
    // Edge
    else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 5);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') !== -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) !== -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

    if (isNaN(majorVersion)) {
        version = '' + parseFloat(navigator.appVersion);
    }

    return {
        browser : browser,
        version : version,
    }
}
const nav_getOsInfo_osAndVersion_f      = (nAgt) => {
    let os = 'unknown';
    let clientStrings = [
        {s:'Windows 10',            r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1',           r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8',             r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7',             r:/(Windows 7|Windows NT 6.1)/},
        {s:'Windows Vista',         r:/Windows NT 6.0/},
        {s:'Windows Server 2003',   r:/Windows NT 5.2/},
        {s:'Windows XP',            r:/(Windows NT 5.1|Windows XP)/},
        {s:'Windows 2000',          r:/(Windows NT 5.0|Windows 2000)/},
        {s:'Windows ME',            r:/(Win 9x 4.90|Windows ME)/},
        {s:'Windows 98',            r:/(Windows 98|Win98)/},
        {s:'Windows 95',            r:/(Windows 95|Win95|Windows_95)/},
        {s:'Windows NT 4.0',        r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s:'Windows CE',            r:/Windows CE/},
        {s:'Windows 3.11',          r:/Win16/},
        {s:enum_osNames.android,    r:/Android/},
        {s:'Open BSD',              r:/OpenBSD/},
        {s:'Sun OS',                r:/SunOS/},
        {s:'Linux',                 r:/(Linux|X11)/},
        {s:enum_osNames.ios,        r:/(iPhone|iPad|iPod)/},
        {s:'Mac OS X',              r:/Mac OS X/},
        {s:'Mac OS',                r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s:'QNX',                   r:/QNX/},
        {s:'UNIX',                  r:/UNIX/},
        {s:'BeOS',                  r:/BeOS/},
        {s:'OS/2',                  r:/OS\/2/},
        {s:'Search Bot',            r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (let id in clientStrings) {
        let cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    let osVersion = 'unknown';
    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(nAgt)[1];
        os = enum_osNames.windows;
    }

    switch (os) {
        case 'Mac OS X':
            osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
            break;

        case 'Android':
            let t = /Android ([\.\_\d]+)/.exec(nAgt)
            osVersion = t != null ? t[1] : "";
            break;

        case 'iOS':
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
    }


    return {
        os      : os,
        version : osVersion
    }
}

// navigator_getRunIn_fe
export const navigator_getRunIn_fe = () => {

    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();

    const isFlutter_b =  userAgent === "tq-app";
    const isAndroidApp =  userAgent === "tq-android";
    const isIosApp = userAgent === "tq-ios";

    const isIos_b = !!platform && /ipad|iphone|ipod/.test(platform);
    const isAndroid_b = userAgent.indexOf("android") > -1; //&& ua.indexOf("mobile");

    const isWindows_b = platform.indexOf('win') > -1
    const isMac_b = platform.indexOf('mac') > -1

    const isInStandaloneMode_b = window.matchMedia('(display-mode: standalone)').matches;

    const isIosSafari_b = !!userAgent.match(/safari/i) && !userAgent.match(/edgios|chrome|crios|opios|mercury|fxios|firefox/i)
    const isIosChrome_b = navigator.userAgent.match('CriOS') != null
    const isChrome_b = window.chrome != null

    const isDesktopSafari_b = window.safari != null


    // === APPLICATION ===
    // 0) flutter
    if(isFlutter_b) {return enum_runIn_es.flutter_app }
    // 1) android app
    if(isAndroidApp) {return enum_runIn_es.android_app }
    // 2) ios app
    if (isIosApp) {return enum_runIn_es.ios_app }

    // === ANDROID pwa/web ===
    // 3) android_pwa_chrome
    if (isAndroid_b && isChrome_b && isInStandaloneMode_b){return enum_runIn_es.android_pwa_chrome}
    // 4) android_web_chrome
    if (isAndroid_b && isChrome_b){return enum_runIn_es.android_web_chrome}
    // 5) android_web_other
    if (isAndroid_b){return enum_runIn_es.android_web_other}

    // === IOS pwa/web ===
    // 8) android_pwa_chrome
    if (isIos_b && isIosChrome_b){return enum_runIn_es.ios_web_chrome}
    // 6) android_pwa_chrome
    if (isIos_b && isIosSafari_b && isInStandaloneMode_b){return enum_runIn_es.ios_pwa_safari}
    // 7) android_pwa_chrome
    if (isIos_b && isIosSafari_b){return enum_runIn_es.ios_web_safari}
    // 9) android_pwa_chrome
    if (isIos_b){return enum_runIn_es.ios_web_other}

    // === WINDOWS ===
    // 10) windows chrome
    if(isWindows_b && isChrome_b){ return enum_runIn_es.windows_chrome}
    // 11) windows other
    if(isWindows_b){return enum_runIn_es.windows_other }

    // === MAC ===
    // 12) mac safari
    if(isMac_b && isDesktopSafari_b){ return enum_runIn_es.mac_safari}
    // 13) mac chrome
    if(isMac_b && isChrome_b){ return enum_runIn_es.mac_chrome}
    // 14) mac other
    if(isMac_b){return enum_runIn_es.mac_other }

    return enum_runIn_es.other

}

